import useSWR, {mutate} from 'swr'
import {camelize} from 'humps'
import {camelizeResult, dineroMoneyObjects} from '../../api/serializer'
import {fetcher} from '../../api'

const paymentMethodBody = (paymentMethod) =>
  paymentMethod[camelize(paymentMethod.type)]

const groupPaymentMethods = (paymentMethods) =>
  paymentMethods.reduce(
    (result, paymentMethod) => {
      const type = camelize(paymentMethod.type)

      return {...result, [type]: [...(result[type] || []), paymentMethod]}
    },
    {debitAgreement: []},
  )

const filterPaymentMethodsByStatus = (paymentMethods, status) =>
  paymentMethods.filter(
    (paymentMethod) => paymentMethodBody(paymentMethod).status === status,
  )

// Helper function to group payment methods
const getGroupedPaymentMethods = (paymentMethods) =>
  groupPaymentMethods(paymentMethods)

export default function usePaymentMethods(supplierId) {
  const url = `/points_on_payments/api/suppliers/${supplierId}/payment_methods`
  const {data, isLoading} = useSWR(url, fetcher, {
    use: [camelizeResult, dineroMoneyObjects],
  })

  const handleRefetch = () => {
    mutate(url)
  }

  const {paymentMethods: unfilteredPaymentMethods = []} = data || {}

  const paymentMethods = filterPaymentMethodsByStatus(
    unfilteredPaymentMethods,
    'active',
  )

  const processingPaymentMethods = filterPaymentMethodsByStatus(
    unfilteredPaymentMethods,
    'processing',
  )

  const groupedPaymentMethods = getGroupedPaymentMethods(paymentMethods)
  const groupedUnfilteredPaymentMethods = getGroupedPaymentMethods(
    unfilteredPaymentMethods,
  )

  const findPaymentMethod = (paymentMethodId) =>
    paymentMethods.find(
      (paymentMethod) =>
        paymentMethodBody(paymentMethod).id === paymentMethodId,
    ) || {}

  return {
    processingPaymentMethods,
    paymentMethods,
    groupedPaymentMethods,
    groupedUnfilteredPaymentMethods,
    findPaymentMethod,
    isLoading,
    handleRefetch,
  }
}
